<template>
<div class="scene" data-3100="top: 100%;" data-4100="top: 0%; " data-13000="top: 0%; " data-14000="top: -100%; display: block;" data-14001="top: -100%; display: none;" style="top: 0%; display: block">
    <div class="section3">
        <div class="section3-inner">
            <img class="threesroad" src="static/fog/section3/road.png" data-3100="left: -28%;" style="left: -28%;" >
            <img class="threeguild" src="static/fog/section3/guild.png" data-4100="top: -100%; display: block;"  data-4600="top: 10%; display: block;" style="top: -100%; display: none;">
            <img class="threeconcepts" src="static/fog/section3/threeconcepts.png" data-4100="top: -100%; display: block;"  data-4600="top: 3%; display: block;" style="top: -100%; display: none;">
            <img class="threegrasses" src="static/fog/section3/grasses.png" data-4100="left: -100%; display: block;"  data-4500="left: 25%; display: block;" style="left: -100%; display: none;">
            <img class="threestones" src="static/fog/section3/stones.png" data-4100="bottom: -100%; display: block;"  data-4500="bottom: 10%; display: block;" style="bottom: -100%; display: none;">
            <img class="threesmalltree" src="static/fog/section3/smalltree.png" data-4100="right: -100%; display: block;"  data-4500="right: 70%; display: block;"  style="right: -100%; display: none;">
            <img class="threefear" src="static/fog/section3/fear.png" data-4600="top: -100%; display: block;"  data-5100="top: 65%; display: block;" style="top: -100%; display: none;">
            <img class="threeobligation" src="static/fog/section3/obligation.png" data-4800="top: -100%; display: block;"  data-5300="top: 45%; display: block;" style="top: -100%; display: none;">
            <img class="threeguilt" src="static/fog/section3/guilt.png" data-5000="top: -100%; display: block;"  data-5500="top: 70%; display: block;" style="top: -100%; display: none;">
            <div class="toolbox5" data-5800="top: 37%; right: 20%; display: none; " data-5801="top: 37%; right: 20%; display: block;" data-6300="top: 37%; right: 20%; display: block;" data-6301="top: 37%; right: 20%; display: none;" style="top: 37%; right: 20%; display: block;">
                <p style="top: 37%; right: 20%; display: block;">為什麼很多看似聰明又有能力的人，卻會被情緒勒索困擾呢？</p>
            </div>
            <div class="toolbox5" data-6400="top: 37%; right: 20%; display: none;" data-6401="top: 37%; right: 20%; display: block;" data-6900="top: 37%; right: 20%; display: block;" data-6901="top: 37%; right: 20%; display: none;" style="top: 37%; right: 20%; display: block;">
                <p style="top: 37%; right: 20%; display: block;">因為勒索者的行動彷彿籠罩在一層<highlight>迷霧</highlight>當中，我們無法看清他們進行恐嚇、掌控的方式。這讓關係狀態模糊不清、使我們缺乏決斷力，更不用說仔細思考回應方法了。</p>
            </div>
            <img class="threefog" src="static/fog/section3/fog.png" data-7400="left: -200%; display: none;" data-7401="left: -200%; display: block;"  data-8200="left: -50%; display: block;" data-12000="left: -50%;opacity: 1; display: block;" data-12500="left: -50%;opacity: 0;  display: block;"  style="left: -200%; display: none;">
            <img class="threefogcloud" src="static/fog/section3/fogcloud.png" data-7600="left: 13%; top: 40%;opacity: 0;display: block;" data-8100="left: 13%; top: 40%;opacity: 1;display: block;"  data-8400="left: 13%;opacity: 1; top: 40%;display: block;" data-8800="left: 13%;opacity: 1; top: -100%; display: block;" style="left: 13%; opacity: 0; top: 40%;display: none;">
            <img class="threeF" src="static/fog/section3/F.png" data-8800="top: -100%; display: block;" data-9300="top: 62.5%; display: block;" data-12000="top: 62.5%; display: block;" data-12500="top: -100%; display: block;" style="top: -100%;display: none;">
            <img class="threeO" src="static/fog/section3/O.png" data-8900="top: -100%; display: block;" data-9400="top: 42.5%; display: block;" data-12000="top: 42.5%; display: block;" data-12500="top: -100%; display: block;" style="top: -100%;display: none;">
            <img class="threeG" src="static/fog/section3/G.png" data-9000="top: -100%; display: block;" data-9500="top: 67.5%; display: block;" data-12000="top: 67.5%; display: block;" data-12500="top: -100%; display: block;" style="top: -100%;display: none;">
            <div class="threefearex toolbox2" data-9500="top: -100%; display: block;" data-9800="top: 34%; display: block;" data-11500="top: 34%; display: block;" data-11800="top: -100%; display: none;" style="top: -100%; display: block;">
                <p><highlight>勒索者的恐懼：</highlight><br>害怕失去、改變、遭到拒絕、無法掌控<br><highlight>被勒索者的恐懼：</highlight><br>勒索者對我們的要脅，例如不再愛我、離我而去、大吼大叫等。</p>
            </div>
            <div class="threeobligationex toolbox2" data-9800="top: -100%; display: block;" data-10100="top:2%; display: block;" data-11200="top: 2%; display: block;" data-11500="top: -100%; display: none;" style="top: -100%; display: block;">
                <p>每個人都會被一些規則和價值約束。<br>情緒勒索者為「施、受」訂定了新的界線，他們不斷強調自己的犧牲、我們應該有所回報。有時甚至利用宗教及社會傳統再次施壓。<br>這讓<highlight>所有愛和甘願的動機，全變成責任與義務</highlight>。</p>
            </div>
            <div class="threeguiltex toolbox2" data-10100="top: -100%; display: block;" data-10400="top: 35%; display: block;" data-10900="top: 35%; display: block;" data-11200="top: -100%; display: none;" style="top: -100%; display: block;">
                <p>作為一個有良知、負責任的人，罪惡感可說是必備的人格要素。勒索者利用責備、控訴、自我懲罰等方式<highlight>替我們冠上罪名</highlight>，使我們相信自己做出了傷害的舉動，而<highlight>引發罪惡感、任由他們予取予求</highlight>。</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            step:1,
        }
    },
    methods:{
        prev() {
            this.step--;
        },
        next3() {
            this.step++;
        }
    }
}
</script>

<style>
@keyframes scale{
    0%{
        transform: scale(1)
    }
    50%{
        transform: scale(1.2) 
    }
    100%{
        transform: scale(1)
    }
}

.section3{
    height: 100%;
    background: #407B5C;
}

.section3-inner{
    width: 1000px;
    height: 100%;
    margin: 0 auto;
    position: relative;
}
.threesroad{
    height: 125%;
    top:-5%;
}
.threeguild{
    height: 30%;
    left: 50%;
    
}
.threeconcepts{
    height: 30%;
    left: 5%;
}

.threegrasses{
    height: 60%;
    top: 10%;
}

.threestones{
    height: 50%;
    left: 5%;
}
.threesmalltree{
    height: 20%;
    top: 35%;
}
.threefear{
    height:15%;
    left: 5%;
}
.threeobligation{
    height:15%;
    left: 30%;
}
.threeguilt{
    height:15%;
    left: 60%;
}
.threefog{
    height: 140%;
    top: 0;
}
.threefogcloud{
    height: 25%;
}
.threeF{
    height: 8%;
    left: 14.3%;
}
.threeO{
    height: 8%;
    left: 38.8%;
}
.threeG{
    height: 8%;
    left: 68.8%;
}
.toolbox5::before{
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    top: -40px;
    left: 60%;
    /* transform: translate(-50%); */
    border-width: 20px;
    border-style: solid;
    border-top-color: transparent;
    border-right-color: transparent;
    border-bottom-color: #fff;
    border-left-color: transparent;
}

.toolbox5{
    width: 30%;
    background-color: #fff;
    border-radius: 5px;
    position: absolute;
    opacity: 0.9;
}
.toolbox5 p,.toolbox2 p{
    padding: 10px 10px 10px 10px; 
}


.toolbox2::after{
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    bottom: -30px;
    left: 50%;
    transform: translate(-50%);
    border-width: 20px;
    border-style: solid;
    border-top-color: #fff;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
}

.toolbox2{
    width: 260px;
    background-color: #fff;
    border-radius: 5px;
    position: absolute;
    opacity: 0.9;
}
.toolbox2 p{
    font-size: 16px;
}
.threefearex{
    left: 2.5%;
}
.threeobligationex{
    left: 27%;
}
.threeguiltex{
    left: 57%;
}
.threearrownext{
    height: 20%;
    top: 75%;
    cursor: pointer;
    animation: scale 2s infinite;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/fog/Section3.vue